const asValue = (value) => typeof value === "string" ? value : value.value;
export {
  asValue as a
};
//# sourceMappingURL=lenkradDate.js.map
